<template>
  <el-table-column
    prop="barcode"
    sortable="custom"
    label="Cikkszám"
    show-overflow-tooltip
    min-width="110"
  >
    <template slot-scope="scope">
      {{ scope.row.barcode || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'barcode',
  };
</script>
